import { GearbeltLoader } from '@gearbelt/ui/icons';
import { useAuth } from 'react-oidc-context';

import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { userManager } from '@/lib/fusionauth';
import { useUserStore } from '@/stores/user.store';
import { clearForceLogoutFlagForSSOSignUp } from '@/utils/auth';

export const SSORedirectionModal = () => {
  const { user, setUser, setOrg } = useUserStore();

  const auth = useAuth();
  setTimeout(async () => {
    logoutAndRedirectToSSOLogin(user?.email as string);
  }, 3000);

  const logoutAndRedirectToSSOLogin = async (email: string) => {
    setUser(null);
    setOrg(null);
    await userManager.removeUser();
    clearForceLogoutFlagForSSOSignUp();
    await auth.signinRedirect({
      extraQueryParams: {
        login_hint: email,
      },
    });
  };

  return (
    <Dialog open={true}>
      <DialogContent>
        <div className="flex h-full w-full flex-col items-center justify-center p-4">
          <GearbeltLoader size={24} />
          <DialogTitle hideCloseButton={true} className="text-xl font-bold">
            Redirecting...
          </DialogTitle>
          <p className="text-center text-sm">You will be redirected to your identity provider to login via single sign on (SSO) shortly...</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
